import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

const CitizenStatsTable = () => {
  const pid = useSelector((state) => state.user.projectId);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const response = await fetch(
          `https://api-project360-insights.haqdarshak.com/kpi/combine-citizens/?pid=${pid}`
        );
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const result = await response.json();
        setData(result);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (pid) {
      fetchData();
    }
  }, [pid]);

  const formatNumber = (num) => {
    return num?.toLocaleString() ?? '0';
  };

  const formatPercent = (num) => {
    return num?.toFixed(2) ?? '0.00';
  };

  const getFormattedDate = (offsetDays) => {
    const date = new Date();
    date.setDate(date.getDate() - offsetDays);

    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });

    // Add ordinal suffix to the day (e.g., 1st, 2nd, 3rd, etc.)
    const suffix =
      day === 1 || day === 21 || day === 31 ? "st" :
      day === 2 || day === 22 ? "nd" :
      day === 3 || day === 23 ? "rd" : "th";

    return `${day}${suffix} ${month}`;
  };

  const dayBeforeYesterday = getFormattedDate(2);
  const yesterday = getFormattedDate(1);

  return (
    <div className="p-6 mt-3 bg-white rounded-lg border-2 max-w-[90vw] ml-[3vw] border-gray-200 shadow-md shadow-black">
      <h2 className="text-2xl font-bold mb-6 text-pink-600 border-b pb-2">State-Wise Citizen Service Statistics (BR) </h2>
      
      {loading && (
        <div className="flex justify-center items-center py-8">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
        </div>
      )}

      {error && (
        <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4 rounded" role="alert">
          <p>Error loading data: {error}</p>
        </div>
      )}

      {!loading && !error && (
        <div className="border border-gray-200 rounded-lg overflow-hidden">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-blue-50">
              <tr>
                <th className="py-2 px-4 text-left text-md font-bold text-gray-700 uppercase tracking-wider border-r border-gray-200">
                  State
                </th>
                <th className="py-2 px-4 text-right text-md font-bold text-gray-700 uppercase tracking-wider border-r border-gray-200">
                  Unique Citizens
                </th>
                <th className="py-2 px-4 text-right text-md font-bold text-gray-700 uppercase tracking-wider border-r border-gray-200">
                  3+ Services
                </th>
                <th className="py-2 px-4 text-right text-md font-bold text-gray-700 uppercase tracking-wider">
                  4+ Services
                </th>
              
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {data.map((item, index) => (
                <tr 
                  key={index} 
                  className={item.state === 'Grand Total' ? 'bg-gray-50 font-semibold' : 'hover:bg-blue-50'}
                >
                  <td className="py-2 px-4 text-md text-gray-800 border-r border-gray-200">
                    {item.state}
                  </td>
                  <td className="py-2 px-4 text-md text-gray-800 text-right border-r border-gray-200">
                    {formatNumber(item.total_citizens)}
                  </td>
                  <td className="py-2 px-4 text-md text-gray-800 text-right border-r border-gray-200">
                    {formatNumber(item.citizens_3plus_services)}
                  </td>
                  <td className="py-2 px-4 text-md text-gray-800 text-right">
                    {formatNumber(item.citizens_4plus_services)}
                  </td>
                  
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default CitizenStatsTable;